import Icon from 'components/Icon/Icon.react';
import Popover from 'components/Popover/Popover.react';
import React from 'react';
import styles from 'components/Notification/Notification.scss';

export default class Notification extends React.Component {
  constructor() {
    super();

    this.state = {
      open: false,
      note: null,
    };

    this.timeout = null;
  }

  componentWillReceiveProps(nextProps) {
    clearTimeout(this.timeout);

    if (nextProps.note && nextProps.note.message) {
      setTimeout(() => {
        this.setState({
          open: true,
          note: nextProps.note,
        });

        this.timeout = setTimeout(() => {
          this.handleCloseAlertMessage();
        }, 3000);
      }, 200);
    }

    if (nextProps.close) {
      this.handleCloseAlertMessage();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleCloseAlertMessage() {
    this.setState({
      open: false,
      note: null,
    });

    if (this.props.onComplete) {
      setTimeout(() => {
        this.props.onComplete();
      }, 400);
    }
  }

  renderMessage(msg) {
    if (Array.isArray(msg)) {
      let messages = []

      for (let i in msg) {
        messages.push(
          <div key={i}>{msg[i]}</div>
        )
      }

      return (
        <div className={styles.messages}>
          {messages}
        </div>
      )
    } 
      return msg
    
  }

  render() {
    if (!this.state.note) {
      return null;
    }

    const classes = [styles.notification, styles[this.state.note.type], !this.state.open ? styles.closeAnimation : null];

    return (
      <div>
        <Popover fixed position={this.state.position}>
          <div className={[styles.notification_wrapper, this.props.fullscreen ? styles.fullscreen : null].join(' ')}>
            <div className={classes.join(' ')}>
              <div>{this.renderMessage(this.state.note.message)}</div>
              { this.props.close
                ?
                  <span
                    className={styles.close}
                    onClick={this.handleCloseAlertMessage.bind(this)}>
                    <Icon name="icon-times" width={10} height={10} fill="#fff" />
                  </span>
                :
                  null
              }
            </div>
          </div>
        </Popover>
      </div>
    );
  }
}
